import { api, apiController, restartApiCotroller } from "@/utils/api";

const getSimulationHistory = async (
  organizationId,
  options = { page: 1, size: 10, simulationId: null, startdate: null, enddate: null, status: null, simulationType: null,referenceId: null }
) => {
  try {
    restartApiCotroller();
    const response = await api.get(
      `/simulations/organizations/${organizationId}`,
      {
        params: {
          page: options.page,
          size: options.size,
          simulationId: options.simulationId || null,
          startdate: options.startdate || null,
          enddate: options.enddate || null,
          status: options.status || null,
          simulationType: options.simulationType || null,
          referenceId: options.referenceId || null,
        },
        signal: apiController.signal,
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getLastSimulation = async () => {
  try {
    restartApiCotroller();
    const response = await api.get(`/simulations/last`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getSimulation = async (simulationId) => {
  try {
    restartApiCotroller();
    const response = await api.get(`/simulations/${simulationId}`);
    // console.log("🚀 ~ file: simulations.js:46 ~ getSimulation ~ response", response)
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export { getSimulationHistory, getLastSimulation, getSimulation };
